import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import type React from 'react';

import { ThemeProvider } from '../providers/ThemeProvider';

const modalProps = {
	padding: 0,
	styles: { header: { display: 'none' } },
};

export const DGLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<ThemeProvider>
			<Notifications limit={3} position="top-right" notificationMaxHeight={50} />
			<ModalsProvider modalProps={modalProps}>{children}</ModalsProvider>
		</ThemeProvider>
	);
};
